import Vue from "vue";
import App from "./App.vue";
// var VueCookie = require("vue-cookie");
import VueLocalStorage from "vue-localstorage";
import axios from "axios";
import VueAxios from "vue-axios";
import dropdown from "vue-dropdowns";

Vue.config.productionTip = false;
// Vue.use(VueCookie);
Vue.use(VueAxios, axios);
Vue.use(dropdown);
Vue.use(VueLocalStorage, {
  name: "ls",
  bind: true
});

// new Vue({
//   el: "#app",
//   template: "<App />"
// });

new Vue({
  render: h => h(App)
}).$mount("#app");
